import React from 'react';

function Privacidad() {
  return (
    <div className="container my-5" style={{ maxWidth: '800px' }}>
      {/* Header */}
      <div className="text-center mb-5">
        <h1 className="display-5 fw-bold mb-3">Aviso de Privacidad</h1>
        <p className="text-muted">LemmonTags</p>
        <p className="text-muted small">Última actualización: 20 de junio de 2025</p>
      </div>

      <hr className="my-4" />

      {/* Preámbulo */}
      <section className="mb-5">
        <div className="alert alert-info">
          <h5 className="alert-heading">
            <i className="bi bi-shield-check me-2"></i>
            Tu Privacidad es Nuestra Prioridad
          </h5>
          <p className="mb-0">
            En LemmonTags, tu privacidad y la seguridad de tu información son nuestra máxima prioridad. 
            Este Aviso de Privacidad describe cómo recopilamos, utilizamos, protegemos y gestionamos tus 
            datos personales, en cumplimiento con la Ley Federal de Protección de Datos Personales en 
            Posesión de los Particulares (LFPDPPP).
          </p>
        </div>
      </section>

      {/* Glosario */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">Glosario</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <strong>Titular:</strong> Eres tú, la persona a quien pertenecen los datos personales.
          </div>
          <div className="col-md-6 mb-3">
            <strong>Responsable:</strong> Somos nosotros, LemmonTags.
          </div>
          <div className="col-md-6 mb-3">
            <strong>Tratamiento:</strong> Cualquier operación con tus datos.
          </div>
          <div className="col-md-6 mb-3">
            <strong>Derechos ARCO:</strong> Acceso, Rectificación, Cancelación y Oposición.
          </div>
        </div>
      </section>

      {/* Sección 1 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">1. Responsable del Tratamiento</h4>
        <p>
          <strong>Inqubits S.A. de C.V.</strong>, en adelante "LemmonTags", con domicilio para oír 
          y recibir notificaciones en Av. Observatorio 468, Colonia 16 de Septiembre, C.P. 06000, 
          Ciudad de México, es el Responsable del tratamiento y protección de los datos personales 
          recabados a través del sitio web <a href="https://lemmontags.com">https://lemmontags.com</a>.
        </p>
      </section>

      {/* Sección 2 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">2. Datos Personales que Recabamos</h4>
        
        <h6 className="fw-bold mt-4">A) Datos Proporcionados por Ti:</h6>
        <ul className="mb-4">
          <li className="mb-2">
            <strong>Identificación y Contacto:</strong> Nombre completo, teléfono y correo electrónico
          </li>
          <li className="mb-2">
            <strong>Datos de tu Mascota/Objeto:</strong> Nombre, especie, raza, color, señas particulares, microchip
          </li>
          <li className="mb-2">
            <strong>Datos Sensibles (Opcionales):</strong> Condiciones médicas, alergias, vacunas, recompensas
          </li>
          <li className="mb-2">
            <strong>Cuenta:</strong> Usuario y contraseña (cifrada)
          </li>
        </ul>

        <h6 className="fw-bold mt-4">B) Datos Recopilados Automáticamente:</h6>
        <ul>
          <li className="mb-2">
            <strong>Geolocalización:</strong> Coordenadas aproximadas cuando se escanea tu QR (voluntario)
          </li>
          <li className="mb-2">
            <strong>Uso y Dispositivo:</strong> IP, navegador, dispositivo, sistema operativo
          </li>
        </ul>
      </section>

      {/* Sección 3 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">3. Uso de tus Datos</h4>
        
        <div className="card mb-3">
          <div className="card-header bg-primary text-white">
            <strong>Finalidades Primarias (Esenciales)</strong>
          </div>
          <div className="card-body">
            <ul className="mb-0">
              <li>Crear y administrar tu cuenta</li>
              <li>Vincular tu Tag físico con tu perfil digital</li>
              <li>Facilitar la recuperación de mascotas/objetos perdidos</li>
              <li>Enviar notificaciones de seguridad y alertas</li>
              <li>Atender solicitudes de soporte y Derechos ARCO</li>
            </ul>
          </div>
        </div>

       <div className="card">
  <div className="card-header bg-secondary text-white">
    <strong>Finalidades Secundarias (Opcionales)</strong>
  </div>
  <div className="card-body">
    <ul className="mb-3">
      <li>Análisis estadísticos para mejorar el servicio</li>
      <li>Comunicaciones promocionales e informativas</li>
      <li>
        <strong>Felicitaciones personalizadas</strong> en fechas especiales 
        (tu cumpleaños o el de tu mascota)
      </li>
      <li>
        <strong>Boletín mensual</strong> con información sobre cuidado de mascotas, 
        estadísticas de uso, y contenido personalizado
      </li>
    </ul>
    
    <div className="alert alert-info mb-3">
      <p className="mb-2">
        <i className="bi bi-bell me-2"></i>
        <strong>Tienes Control Total:</strong>
      </p>
      <p className="mb-0 small">
        Puedes desactivar estas comunicaciones desde tu{" "}
        <strong>Panel de Usuario</strong> o haciendo clic en 
        "Cancelar suscripción" al final de cada email.
      </p>
    </div>
    
    <p className="mb-0 small">
      <strong>¿No deseas recibir estas comunicaciones?</strong> Envía un correo a{" "}
      <a href="mailto:privacidad@lemmontags.com">privacidad@lemmontags.com</a>
    </p>
  </div>
</div>
      </section>

      {/* Sección 4 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">4. Compartir Información</h4>
        <p className="fw-bold">LemmonTags NO vende tus datos. Solo compartimos en estos casos:</p>
        <ul>
          <li className="mb-2">
            <strong>Control del Usuario:</strong> Tú decides qué información hacer pública en "modo perdido"
          </li>
          <li className="mb-2">
            <strong>Proveedores de Servicio:</strong> Firebase, AWS, servicios de email (bajo contrato de confidencialidad)
          </li>
          <li className="mb-2">
            <strong>Requerimiento Legal:</strong> Solo cuando sea obligatorio por ley
          </li>
        </ul>
      </section>

      {/* Sección 5 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">5. Cookies</h4>
        <p>Utilizamos cookies para:</p>
        <ul>
          <li><strong>Esenciales:</strong> Mantener tu sesión y preferencias</li>
          <li><strong>Análisis:</strong> Entender cómo usas la plataforma (anónimo)</li>
        </ul>
        <p className="small text-muted">Puedes deshabilitarlas en tu navegador, pero puede afectar la funcionalidad.</p>
      </section>

      {/* Sección 6 - Derechos ARCO */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">6. Tus Derechos ARCO</h4>
        <div className="alert alert-warning">
          <h6 className="alert-heading">Puedes ejercer tus derechos en cualquier momento:</h6>
          <ul className="mb-3">
            <li><strong>Acceso:</strong> Conocer qué datos tenemos</li>
            <li><strong>Rectificación:</strong> Corregir datos incorrectos</li>
            <li><strong>Cancelación:</strong> Eliminar tus datos</li>
            <li><strong>Oposición:</strong> Negarte a ciertos usos</li>
          </ul>
          <p className="mb-2"><strong>Contacto:</strong></p>
          <p className="mb-0">
            <i className="bi bi-envelope me-2"></i>
            <a href="mailto:privacidad@lemmontags.com">privacidad@lemmontags.com</a>
          </p>
          <p className="mb-0 mt-2 small">
            Incluye: Tu nombre, identificación oficial, y descripción clara de tu solicitud.
            <br />
            Responderemos en máximo 20 días hábiles.
          </p>
        </div>
      </section>

      {/* Secciones Restantes */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">7. Seguridad</h4>
        <p>
          Implementamos medidas de seguridad técnicas, físicas y administrativas: protocolos SSL, 
          bases de datos seguras, y acceso restringido.
        </p>
      </section>

      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">8. Conservación de Datos</h4>
        <p>
          Tus datos se conservan mientras tu cuenta esté activa. Al cancelarla, se eliminan de forma 
          segura, conservando solo lo que la ley requiera.
        </p>
      </section>

      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">9. Cambios a este Aviso</h4>
        <p>
          Podemos actualizar este documento. Te notificaremos por email o en la plataforma.
        </p>
      </section>

      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">10. Consentimiento</h4>
        <p>
          Al usar LemmonTags, aceptas este Aviso de Privacidad y el tratamiento de tus datos personales.
        </p>
      </section>

      {/* Footer */}
      <div className="text-center mt-5 pt-4 border-top">
        <p className="text-muted">
          ¿Dudas sobre privacidad?{" "}
          <a href="mailto:privacidad@lemmontags.com">privacidad@lemmontags.com</a>
        </p>
      </div>
    </div>
  );
}

export default Privacidad;